import Btn from '../utils/btn';

const func = $target => {
    // var $tickets = $target.find('[data-ticket]');
    // $tickets.each
    // console.log($tickets.data('ticket'));
    var $viewModal = $target.find('.modal#ticketViewer'),
        $editModal = $target.find('.modal#attendeeEdit'),
        $downloadButton = $viewModal.find('#ticketViewerDownload'),
        $viewTitle = $viewModal.find('#ticketViewerTitle'),
        $qrcode = $viewModal.find('#ticketViewerImg'),
        $editTitle = $editModal.find('#attendeeEditTitle'),
        $editId = $editModal.find('input[data-ticket-id]'),
        $editFirstName = $editModal.find('input[name="fields[ticketFirstName]"]'),
        $editLastName = $editModal.find('input[name="fields[ticketLastName]"]'),
        $email = $editModal.find('input[name="fields[email]"]'),
        $ticketConsent = $editModal.find('input[name="ticketConsent"]'),
        $jobTitle = $editModal.find('select[name="fields[jobTitle]"]'),
        $editSubmit = new Btn($editModal.find('button[type="submit"]')),
        $ticketEmails = $target.data('emails'),
        $downloadAllForm = $target.find('[data-type="download-all-form"]'),
        $downloadAllMessage = $target.find('[data-type="download-all-message"]');

    $viewModal
        .on('show.bs.modal', function(e) {
            var data = $(e.relatedTarget).closest('.card').data('ticket');

            $viewTitle.text(data.title);
            $downloadButton.attr('href', data.pdfurl);
            $qrcode.attr('src', data.qrcode);
        })
        .on('hidden.bs.modal', function(e) {
            $viewTitle.text('');
            $downloadButton.attr('href', '');
            $qrcode.attr('src', '');
        });

    $editModal
        .on('show.bs.modal', function(e) {
            var data = $(e.relatedTarget).closest('.card').data('ticket');

            $editTitle.text('Edit Attendee for ' + data.title);
            $editId.val(data.id);
            $editFirstName.val(data.firstName);
            $editLastName.val(data.lastName);
            $email.val(data.email);
            $jobTitle.val(data.jobTitle).change();

            $editSubmit.enable();

            $email.on('change', function(e) {
                var $this = $(this);

                if($ticketEmails.includes($this.val())) {
                    this.setCustomValidity('emailExists');
                } else {
                    this.setCustomValidity('');
                }
            })
            
        })
        .on('hidden.bs.modal', function(e) {
            $editTitle.text('');
            $editId.val('');
            $editFirstName.val('');
            $editLastName.val('');
            $email.val('');
            $jobTitle.prop('selectedIndex', 0);
            $ticketConsent.prop('checked',false);
            $editSubmit.processed();
            $editSubmit.disable();
        });

    $editModal.find('form').on('submit',function(e) {
        e.preventDefault();
        let form = $(this);
        $.ajax({
            type: "POST",
            url: '/',
            dataType: 'json',
            data: form.serialize(), // serializes the form's elements.
            success: function(response) {
                // console.log(response);
                if (response.purchasedTicket) {
                    let data = response.purchasedTicket;
                    let $card = $target.find(`.card[data-ticket-id="${data.id}"]`);
                    let cardData = $card.data('ticket');
                    cardData.firstName = data.ticketFirstName;
                    cardData.lastName = data.ticketLastName;
                    $card.data('ticket',cardData);
                    $card.find('span[data-role="ticketFirstName"]').text(data.ticketFirstName);
                    $card.find('span[data-role="ticketLastName"]').text(data.ticketLastName);
                    $card.find('span[data-role="ticketEmail"]').html('<br>' + data.email);
                    $card.find('span[data-role="ticketJobTitle"]').html('<br>' + data.jobTitle.label);
                    $ticketEmails.push(data.email);
                    $target.attr('data-emails',JSON.stringify($ticketEmails));
                    $card.find('[data-target="#attendeeEdit"]').attr('data-target','#attendeeComplete');
                    $card.find('[data-type="view-ticket"]').attr('data-target','#ticketViewer');
                    $card.find('[data-type="download-message"]').addClass('d-none');
                    $card.find('[data-type="download-ticket"]').removeClass('d-none');

                    // check all cards have a firstname
                    var $noName = $target.find('.card').filter(function() {
                        return $(this).data('ticket').firstName === '';
                    });
                    
                    if($noName.length == 0) {
                        $downloadAllForm.removeClass('d-none');
                        $downloadAllMessage.addClass('d-none');
                    }

                    $editModal.modal('hide');
                }  
            },
        });
    });
}
export default func;